import { useSwiper } from 'swiper/react';

import { ChevronLeft } from '@src/components/atoms/icons/chevron-left';
import { ChevronRight } from '@src/components/atoms/icons/chevron-right';

import { Button, Wrapper } from './styles';

const NavigationArrows = () => {
  const swiper = useSwiper();

  if (!swiper.allowSlideNext && !swiper.allowSlidePrev) {
    return <></>;
  }

  return (
    <Wrapper>
      {swiper.allowSlidePrev && (
        <Button type="button" onClick={() => swiper.slidePrev()}>
          <ChevronLeft />
        </Button>
      )}
      {swiper.allowSlideNext && (
        <Button type="button" onClick={() => swiper.slideNext()}>
          <ChevronRight />
        </Button>
      )}
    </Wrapper>
  );
};
export default NavigationArrows;
